export default __webpack_public_path__ + "static/media/user-time-spend.66669039.svg";